module.exports = __webpack_public_path__ + "img/Y.66f53d1e.png";